<template>
  <div class="main-content">
    <div class="table-content">
      <avue-crud
        :data="data"
        :option="option"
        :search.sync="search"
        :page.sync="pageSync"
        @search-change="searchChange"
        @search-reset="searchReset"
        @on-load="onLoad"
        ref="crud"
      >
        <!-- 头部：搜索条件 + 操作按钮 -->
        <template #header>
          <div>
            <div class="flex flex-wrap align-items marginBottom20">
              <!-- 管理员姓名 -->
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10 width90 textAlignRight"
                  >管理员姓名 :
                </span>
                <div class="width300">
                  <el-input
                    v-model="fullName"
                    placeholder="请输入管理员姓名"
                    clearable
                  ></el-input>
                </div>
              </div>

              <!-- 重置按钮 -->
              <div class="flex align-items marginRight10 marginBottom10">
                <el-button size="medium" type="info" @click="handleReset"
                  >重置</el-button
                >
              </div>

              <!-- 查询按钮 -->
              <div class="flex align-items marginRight10 marginBottom10">
                <el-button size="medium" type="primary" @click="handleSearch"
                  >查询</el-button
                >
              </div>

              <!-- 新增按钮 -->
              <div class="flex align-items marginRight10 marginBottom10">
                <el-button
                  size="medium"
                  type="primary"
                  @click.stop="clickMenu('add')"
                  >新增</el-button
                >
              </div>
            </div>
          </div>
        </template>
        <template slot="headPortrait" slot-scope="{ row }">
          <el-image
            style="width: 80px; height: 80px"
            :src="row.headPortrait"
            :preview-src-list="[row.headPortrait]"
          >
          </el-image>
        </template>
        <template slot="state" slot-scope="{ row }">
          <el-switch
            :value="row.state"
            :inactive-value="2"
            :active-value="1"
            @change="handleSwitch($event, row.id)"
          ></el-switch>
        </template>
        <template slot="auditPermission" slot-scope="{ row }">
          <el-switch
            :value="row.auditPermission"
            :inactive-value="0"
            :active-value="1"
            @change="handleAuditPermissionSwitch($event, row.id)"
          ></el-switch>
        </template>

        <template slot="menu" slot-scope="{ row }">
          <el-button
            style="margin-left: 10px"
            size="small"
            type="text"
            @click.stop="clickMenu('edit', row)"
            >编辑
          </el-button>

          <el-button
            style="margin-left: 10px"
            size="small"
            type="text"
            @click.stop="clickMenu('transfer', row)"
            >交接
          </el-button>

          <!-- <el-button style="margin-left:10px;"
                            size="small"
                            type="text"
                            @click.stop="clickMenu('reset',row)">密码重置</el-button>

                    <el-button style="margin-left:10px;"
                            size="small"
                            type="text"
                            @click.stop="clickMenu('auth',row)">授权</el-button> -->

          <el-button
            style="margin-left: 10px"
            size="small"
            type="text"
            @click.stop="clickMenu('cel', row)"
            >删除</el-button
          >
        </template>

        <!-- <template slot-scope="{row,index,type}" slot="menuForm">
                    <el-button type="primary"
                               icon="el-icon-circle-plus-outline"
                               size="small"
                               v-if="type=='add'"
                               @click="$refs.crud.rowSave()"
                    >保存</el-button>
                    <el-button type="primary"
                               size="small"
                               v-if="type=='edit'"
                               @click="$refs.crud.rowUpdate()"
                    >修改</el-button>
                    <el-button
                               icon="el-icon-circle-close"
                               size="small"
                               plain
                               @click="$refs.crud.closeDialog()"
                    >取消</el-button>
                </template> -->
      </avue-crud>
    </div>

    <Role
      v-if="dialogVisible_role"
      :dialogVisible="dialogVisible_role"
      :choiceId="choiceId"
    />
    <Edit
      v-if="dialogVisible_edit"
      :dialogVisible="dialogVisible_edit"
      :choiceId="choiceId"
    />
    <Add
      v-if="dialogVisible_add"
      :dialogVisible="dialogVisible_add"
      :choiceId="choiceId"
    />
    <LookView
      v-if="dialogVisible_view"
      :dialogVisible="dialogVisible_view"
      :choiceId="choiceId"
    />

    <!-- 审核数据交接弹窗 -->
    <el-dialog
      title="审核数据移交"
      :visible.sync="dialogVisible_transfer"
      width="500px"
      v-dialogdrag
      :close-on-click-modal="false"
      :before-close="handleTransferClose"
    >
      <el-form
        ref="transferFormRef"
        :model="transferForm"
        :rules="transferRules"
        label-width="100px"
      >
        <el-form-item label="原用户">
          <el-input
            :value="
              currentTransferUser
                ? `${currentTransferUser.fullName} (${currentTransferUser.username || ''})`
                : ''
            "
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="接收人员" prop="transferUserId">
          <el-select
            v-model="transferForm.transferUserId"
            placeholder="请选择接收人员"
            filterable
            style="width: 100%"
            :loading="transferLoading"
          >
            <el-option
              v-for="item in auditUserList"
              :key="item.id"
              :label="
                item.post
                  ? `${item.fullName} - ${item.post}`
                  : item.fullName
              "
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleTransferClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="transferSubmitLoading"
          @click="submitTransfer"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Role from "@/components/system/user/role";
import Edit from "@/components/system/user/edit";
import Add from "@/components/system/user/add";
import LookView from "@/components/system/user/lookview";
import {
  passwordReset,
  userDelete,
  userlist,
  userStateUpdate,
  userAuditList,
  userAuditPermissionUpdate,
  userAuditTransfer,
} from "@/api/system/index";
import { mapActions } from "vuex";

export default {
  name: "role",
  components: {
    Add,
    Role,
    Edit,
    LookView,
  },
  data() {
    return {
      Buttons: [], //表格按钮
      search: {},
      data: [],
      option: {
        title: "",
        titleSize: "h3",
        page: true, // 显示分页
        card: false,
        emptyText: "暂无数据",
        stripe: false,
        showHeader: true,
        border: true,
        align: "center",
        menuAlign: "center",
        columnBtn: false, //列显隐
        refreshBtn: false, //刷新
        saveBtn: false,
        updateBtn: false,
        cancelBtn: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false, //隐藏搜索条件区域卡片切换

        column: [
          {
            label: "管理员姓名",
            prop: "fullName",
          },
          {
            label: "头像",
            prop: "headPortrait",
          },
          {
            label: "邮箱",
            prop: "email",
          },
          {
            label: "身份",
            prop: "roleName",
          },
          {
            label: "账号",
            prop: "username",
          },
          {
            label: "职位",
            prop: "post",
          },
          {
            label: "是否启用",
            prop: "state",
          },
          {
            label: "审核权限",
            prop: "auditPermission",
            slot: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },
      ids: [], //选择数据

      dialogVisible_role: false, //用户角色管理
      dialogVisible_edit: false, //用户编辑
      dialogVisible_add: false, //用户添加
      dialogVisible_view: false, //用户查看
      dialogVisible_transfer: false, // 审核数据移交弹窗
      currentTransferUser: null, // 当前交接的原用户
      transferForm: {
        transferUserId: "",
      },
      transferRules: {
        transferUserId: [
          { required: true, message: "请选择接收人员", trigger: "change" },
        ],
      },
      auditUserList: [], // 可选审核用户列表
      transferLoading: false, // 审核用户列表加载中状态
      transferSubmitLoading: false, // 移交提交中状态
      choiceId: "",
      page: 1,
      pageSize: 10,
      fullName: "",
      phone: "",
      username: "",

      pageSync: {
        total: 0,
        currentPage: 1,
      },
    };
  },
  mounted() {
    let that = this;
    that.Buttons = that.$store.state.index.menuSubButtons;

    that.getRole(); //用户管理-角色列表
    that.getParent(); //用户管理-归属上级

    that.$root.eventHub.$on("changeRole", (n) => {
      that.dialogVisible_role = false;
      if (n) {
        that.user_list();
      }
    });
    that.$root.eventHub.$on("changeEdit", (n) => {
      that.dialogVisible_edit = false;
      if (n) {
        that.user_list();
      }
    });
    that.$root.eventHub.$on("changeAdd", (n) => {
      that.dialogVisible_add = false;
      if (n) {
        that.user_list();
      }
    });
    that.$root.eventHub.$on("changeView", (n) => {
      that.dialogVisible_view = false;
    });
  },
  methods: {
    ...mapActions(["getRole", "getParent"]),

    /**
     * 获取系统管理员用户列表
     * @returns {void}
     */
    user_list() {
      userlist({
        page: this.pageSync.currentPage,
        size: this.pageSync.pageSize,
        fullName: this.fullName,
        phone: this.phone,
        username: this.username,
      })
        .then((res) => {
          this.data = res.data.records;
          this.pageSync.total = res.data.total;
          this.pageSync.currentPage = res.data.current;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },

    /**
     * 触发搜索查询操作
     * @returns {void}
     */
    handleSearch() {
      this.pageSync.currentPage = 1;
      this.user_list();
    },

    /**
     * 触发搜索条件重置操作
     * @returns {void}
     */
    handleReset() {
      this.fullName = "";
      this.phone = "";
      this.username = "";
      this.pageSync.currentPage = 1;
      this.user_list();
    },

    /**
     * 表格加载与翻页回调
     * @returns {void}
     */
    onLoad() {
      this.user_list();
    },

    /**
     * 打开用户角色授权弹窗
     * @param {Object} form - 当前行用户信息
     * @returns {void}
     */
    handleGrant(form) {
      this.dialogVisible_role = true;
      this.choiceId = form.id;
    },

    /**
     * 打开修改员工弹窗
     * @param {Object} form - 当前行用户信息
     * @returns {void}
     */
    clickedit(form) {
      this.choiceId = form.id;
      this.dialogVisible_add = true;
    },

    /**
     * 菜单与按钮点击事件分发
     * @param {string} name - 操作类型标识
     * @param {Object} [form] - 当前行用户信息
     * @returns {void}
     */
    clickMenu(name, form) {
      if (name == "add") {
        this.dialogVisible_add = true;
        this.choiceId = "";
        return;
      }
      if (name == "cel") return this.UserDelete(form.id);
      if (name == "auth") return this.handleGrant(form);
      if (name == "edit") return this.clickedit(form);
      if (name == "transfer") return this.handleTransfer(form);
      if (name == "reset") {
        this.PasswordReset(form);
      }
    },

    /**
     * 重置用户密码为默认密码
     * @param {Object} form - 当前行用户信息
     * @returns {void}
     */
    PasswordReset(form) {
      this.$confirm(`密码重置`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: (action) => {
          if (action == "confirm") {
            passwordReset(form.id)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "重置密码为123456",
                    duration: 5000,
                    type: "success",
                  });
                  this.$message.success(res.msg);
                }
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          }
        },
      });
    },

    /**
     * 打开用户查看弹窗
     * @param {Object} form - 当前行用户信息
     * @returns {void}
     */
    clickView(form) {
      this.choiceId = form.id;
      this.dialogVisible_view = true;
    },

    /**
     * 删除指定系统用户
     * @param {string} [id] - 用户ID
     * @returns {void}
     */
    UserDelete(id) {
      let that = this;
      this.$confirm(`删除这条数据`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: (action) => {
          if (action == "confirm") {
            userDelete(id == undefined ? this.ids : id)
              .then((res) => {
                if (res.code === 200) {
                  that.user_list();
                  that.$message.success(res.msg);
                }
              })
              .catch((err) => {
                that.$message.error(err.msg);
              });
          }
        },
      });
    },

    /**
     * 搜索栏搜索条件变化回调
     * @param {Object} params - 搜索参数
     * @param {Function} done - 完成回调
     * @returns {void}
     */
    searchChange(params, done) {
      this.fullName = params.fullName == undefined ? "" : params.fullName;
      this.phone = params.phone == undefined ? "" : params.phone;
      this.username = params.username == undefined ? "" : params.username;
      this.user_list();
      done();
    },

    /**
     * 搜索栏重置回调
     * @param {Object} params - 搜索参数
     * @returns {void}
     */
    searchReset(params) {
      this.fullName = params.fullName;
      this.phone = params.phone;
      this.username = params.username;
      this.user_list();
    },

    /**
     * 切换用户启用/禁用状态
     * @param {number} e - 状态值 (1: 启用, 2: 禁用)
     * @param {string} id - 用户ID
     * @returns {void}
     */
    handleSwitch(e, id) {
      userStateUpdate({
        id: id,
        state: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },

    /**
     * 切换用户审核权限状态
     * @param {number} e - 审核权限值 (0: 否/关闭, 1: 开启)
     * @param {string} id - 用户ID
     * @returns {void}
     */
    handleAuditPermissionSwitch(e, id) {
      userAuditPermissionUpdate({
        id: id,
        auditPermission: e,
      })
        .then((res) => {
          if (res.code === 200 || res.success) {
            this.$message.success("修改审核权限成功");
          }
          this.onLoad();
        })
        .catch((err) => {
          this.$message.error(err.msg || "修改审核权限失败");
          this.onLoad();
        });
    },

    /**
     * 打开审核数据移交弹窗并加载可选的审核用户列表
     * @param {Object} row - 当前行选中的用户信息
     * @returns {void}
     */
    handleTransfer(row) {
      this.currentTransferUser = row;
      this.transferForm.transferUserId = "";
      this.auditUserList = [];
      this.dialogVisible_transfer = true;
      this.transferLoading = true;
      userAuditList({ id: row.id })
        .then((res) => {
          this.transferLoading = false;
          if (res.code === 200 || res.success) {
            this.auditUserList = res.data || [];
          }
        })
        .catch((err) => {
          this.transferLoading = false;
          this.$message.error(err.msg || "获取审核用户列表失败");
        });
    },

    /**
     * 关闭审核数据移交弹窗并重置表单
     * @returns {void}
     */
    handleTransferClose() {
      this.dialogVisible_transfer = false;
      this.currentTransferUser = null;
      this.transferForm.transferUserId = "";
      if (this.$refs.transferFormRef) {
        this.$refs.transferFormRef.resetFields();
      }
    },

    /**
     * 提交审核数据移交请求
     * @returns {void}
     */
    submitTransfer() {
      this.$refs.transferFormRef.validate((valid) => {
        if (valid) {
          this.transferSubmitLoading = true;
          userAuditTransfer({
            originalUserId: this.currentTransferUser.id,
            transferUserId: this.transferForm.transferUserId,
          })
            .then((res) => {
              this.transferSubmitLoading = false;
              if (res.code === 200 || res.success) {
                this.$message.success(res.msg || "移交成功");
                this.handleTransferClose();
                this.user_list();
              }
            })
            .catch((err) => {
              this.transferSubmitLoading = false;
              this.$message.error(err.msg || "移交失败");
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>

